export const UPDATE_MARKETPLACE_RETURN_ITEM = 'UPDATE_MARKETPLACE_RETURN_ITEM';
export const SET_MARKETPLACE_RETURN_ITEMS = 'SET_MARKETPLACE_RETURN_ITEMS';
export const SUBMIT_MARKETPLACE_RETURN = 'SUBMIT_MARKETPLACE_RETURN';
export const SUBMIT_MARKETPLACE_RETURN_SUCCESS = 'SUBMIT_MARKETPLACE_RETURN_SUCCESS';
export const SUBMIT_MARKETPLACE_RETURN_FAILURE = 'SUBMIT_MARKETPLACE_RETURN_FAILURE';
export const CLEAR_RETURN_SUCCESS_FAILURE_INFO = 'CLEAR_RETURN_SUCCESS_FAILURE_INFO';
